export default "__VITE_ASSET__B5fN582d__"